import { useState, useEffect } from 'react';
import Modal from '../modal/modal';
import Card from '../card/Card';
import Input from '../input/Input';
import { toast } from 'react-toastify';

interface UpdateFundsModalProps {
  isOpen: boolean;
  onClose: () => void;
  fieldName: 'authorized_risk_fund' | 'maximum_leverage';
  fieldLabel: string;
  currentValue: number;
  onUpdate: (fieldName: string, newValue: number) => Promise<void>;
}

const UpdateFundsModal = ({
  isOpen,
  onClose,
  fieldName,
  fieldLabel,
  currentValue,
  onUpdate,
}: UpdateFundsModalProps) => {
  const [value, setValue] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setValue(currentValue.toString());
    }
  }, [isOpen, currentValue]);

  const handleUpdate = async () => {
    const numValue = parseFloat(value);
    
    if (isNaN(numValue) || numValue < 0) {
      toast.error('Ingrese un valor válido');
      return;
    }

    setIsLoading(true);
    try {
      await onUpdate(fieldName, numValue);
      toast.success(`${fieldLabel} actualizado exitosamente`);
      onClose();
    } catch (error) {
      toast.error(`Error al actualizar ${fieldLabel}`);
      console.error('Error updating funds:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Actualizar ${fieldLabel}`}
      width='500px'
      primaryText='Aceptar'
      primaryVariant='primary'
      onPrimaryAction={handleUpdate}
      secondaryText='Cancelar'
      secondaryVariant='contained'
      onSecondaryAction={onClose}
      showOverlay={true}
    >
      <Card margin={{ top: '4' }}>
        <Input
          label={fieldLabel}
          name={fieldName}
          type='number'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={isLoading}
        />
      </Card>
    </Modal>
  );
};

export default UpdateFundsModal;
